import { useState, useContext } from "react";
import * as userApi from "../../../service/userApi";
import { HashLoader } from "react-spinners";
import PageHeader from "../../pageheader/PageHeader";
import { useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../../App";
import Breadcrumb from "../../public/breacrumb/breadcrumb";
import ChangePasswordComponent from "../../material/changePassword";

function ChangePass({ role }) {
  const { setIsMessage } = useContext(CurrentUserContext);
  // const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const onClickSubmit = async () => {
    if (!newPass || !confirmPassword) {
      // !currentPass ||
      setIsMessage({ type: "warning", data: "กรุณากรอกข้อมูลให้ครบถ้วน" });
    } else {
      setLoading(true);
      let res = await userApi.changPass(newPass, confirmPassword); // currentPass,
      setLoading(false);
      if (res) {
        if (res?.data?.code === 200) {
          setIsMessage({ type: "success", data: "เปลี่ยนรหัสผ่านสำเร็จ" });
          nav("/patient/laboratoryresult");
        } else {
          setIsMessage({
            type: "warning",
            data: res?.data?.message_th || res?.data?.message,
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }
  };

  const pathItems = [
    { name: "หน้าหลัก", url: `/` },
    { name: "เปลี่ยนรหัสผ่าน", url: `${role ?? ""}/changePassword` },
  ];

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={"เปลี่ยนรหัสผ่าน"} />

        {loading ? (
          <div className="flex flex-col justify-center items-center h-40 w-full">
            <HashLoader color="#FF9768" size={70} />
            <div
              style={{
                marginTop: "20px",
                color: "#FF9768",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              loading...
            </div>
          </div>
        ) : (
          <ChangePasswordComponent
            newPass={newPass}
            setNewPass={setNewPass}
            confirmPassword={confirmPassword}
            setConfirmPassword={setConfirmPassword}
            onClickSubmit={onClickSubmit}
          />
        )}
      </div>
    </>
  );
}
export default ChangePass;
